import React from "react";
import styled from "styled-components";
import Link from "../../styles/shared/Links/Link";
import LinkWrap from "../../styles/shared/Links/LinkWrap";
import { breakpoints, maxWidth } from "../../styles/variables/breakpoints";

interface WebsiteLinkProps {
  website: string;
}

const Website = styled(Link)`
  background-image: url("/modules/custom/custom_react_maps/img/website-blue.svg");
  background-size: 1.4rem;
  ${maxWidth(breakpoints.md)} {
    font-size: 12px;
    line-height: 14px;
  }
  ${maxWidth(breakpoints.sm)} {
    font-size: 9px;
    line-height: 11px;
    background-size: 0;
    background-image: none;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

const WebsiteLink = (props: WebsiteLinkProps) => {
  const { website } = props;

  return (
    <LinkWrap>
      <Website target="_blank" href={website}>
        {website}
      </Website>
    </LinkWrap>
  );
};

export default WebsiteLink;
